import { MediaPack } from '@calm/evexia-web-sdk';
import { defaultCarouselCardSpacing } from '@rhg/components/carousel/utils';
import { PackCarousel } from '@rhg/components/pack-carousel';
import { Divider, Typography } from '@rhg/libs/material';
import { STYLE_SECTION_DIVIDER } from '@rhg/utils/ui';
import {
    DiscoverFullWidthContainer,
    DiscoverPaddedContainer,
    discoverPaddingPx,
} from '../layout';

export const dailyPracticeCardWidth = 326;
export const dailyPracticeCardHeight = 352;

interface DailiesPacksSectionProps {
    isFetched: boolean;
    discoverDailyPack?: MediaPack;
}
export const DailiesPacksSection = ({
    isFetched,
    discoverDailyPack,
}: DailiesPacksSectionProps) => {
    return (
        <div data-testid="DailiesPacksSection">
            {discoverDailyPack?.title && (
                <Typography variant="srOnly" component="h2">
                    {discoverDailyPack?.title}
                </Typography>
            )}
            <DiscoverFullWidthContainer>
                <PackCarousel
                    isFullscreen
                    pack={discoverDailyPack}
                    cardVariant="carousel"
                    itemWidth={
                        dailyPracticeCardWidth + defaultCarouselCardSpacing
                    }
                    itemSpacing={defaultCarouselCardSpacing}
                    firstItemOffsetPx={discoverPaddingPx}
                    trackBackButton="DiscoverCarouselBack"
                    trackForwardButton="DiscoverCarouselForward"
                    isFetched={isFetched}
                    skeletonType="daily"
                    skeletonCardSizingProps={{
                        imageHeight: dailyPracticeCardWidth,
                        cardHeight: dailyPracticeCardHeight,
                        addContainerSpacing: true,
                    }}
                    allowPackOfPacks
                    sortAlphabetically
                />
            </DiscoverFullWidthContainer>
            <DiscoverPaddedContainer>
                <Divider sx={STYLE_SECTION_DIVIDER} />
            </DiscoverPaddedContainer>
        </div>
    );
};
